module.exports = __webpack_public_path__ + "img/pessoa-montando-blocos.jpg";